import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {
  InputTextWrapper,
  SelectWrapper,
  InputDateWrapper,
} from '../../../../../../components/UI/Form/Input'
import {ModalComponent} from '../../../../components/Modal'
import moment from 'moment'
import {startProcessWash, getLaundryConfigHoursBySupplierId} from '../../../../services'
import useTableForMaster from '../../../../hooks/useTableForMaster'
import {useSupplierBySite} from '../../../../hooks'
import {Switch} from '../../../../../../components/UI/Switch'
import {ShowSnackBar, confirmModal} from '../../../../../../util/functions'
import {SUCCESS_MESSAGE_CREATE} from '../../../../../../util/Constants'
import Swal from 'sweetalert2'
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {yupResolver} from '@hookform/resolvers/yup'
import {processWashEBatch} from '../../../../schema/laundryBatch'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  data?: any[]
  tipoLavado?: string
}

const LavadoExterno: FC<Props> = ({show, setShow, data = [], tipoLavado}) => {
  const {changeCurrentTabItem, currentTabItem} = useLavanderia()
  const [searching, setIsSearching] = useState<boolean>(false)
  const [days, setDays] = useState(0)
  const methods = useForm({
    resolver: yupResolver(processWashEBatch),
  })

  const {
    setValue,
    handleSubmit,
    register,
    setError,
    formState: {errors},
  } = methods
  const {washingPlace, getWashingPlaceList} = useTableForMaster()
  const {getSupplierBySiteList, supplierBySite} = useSupplierBySite()
  const {data: dataTable, setUpdateTable} = useKTable()
  const onSubmit = async (dataForm: any) => {
    try {
      setIsSearching(true)
      let obj = {
        ...dataForm,
        TipoProceso: 'LAVADO',
        ordenIds: data,
        tipoLavado,
      }
      const result = await confirmModal({
        title: 'Esta seguro de generar Lote',
        bodyText: '',
        icon: 'warning',
        showCancelButton: true,
        textButtonCancel: 'No',
        textButtonConfirm: 'Sí',
      })
      if (result.isConfirmed) {
        const {data: response} = await startProcessWash(obj)
        if (!response.error) {
          ShowSnackBar(SUCCESS_MESSAGE_CREATE)
          setUpdateTable(true)
          setShow(false)
          // changeCurrentTabItem({
          //   ...currentTabItem,
          //   typeAdmin: '',
          //   typeProcess: '',
          // })
          Swal.close()
        } else {
          ShowSnackBar(response.message, 'error')
        }
      } else {
        setIsSearching(false)
      }
    } catch (error) {
      ShowSnackBar('ERROR DEL SISTEMA', 'error')
    }
  }
  useEffect(() => {
    getWashingPlaceList()
    getSupplierBySiteList()
    setValue('fechaEntregaProveedor', moment().format('YYYY-MM-DD'))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    setValue('countOrder', data.length)
    setValue('iniciarLavado', true)
    validateSupplier()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  useEffect(() => {
    const value =
      washingPlace.filter((item) => item.codigo === 'LAVADO EN PROVEEDOR')[0]?.label || ''
    setValue('lugarLavado', value)
  }, [washingPlace])
  const getDays = async (id: any) => {
    const result = await getLaundryConfigHoursBySupplierId(id)
    if (!result.data.error) {
      setDays(result.data.data || 0)
      let addDays = moment().add(result.data.data?.Valor || 0, 'days')

      setValue('fechaProgramadaProveedor', addDays.format('YYYY-MM-DD'))
    }
  }
  const validateSupplier = () => {
    const filteredData = dataTable.filter((item) => data.includes(item.id))
    let selectedItem = filteredData[0]
    let supplier = selectedItem.proveedorId
    const isSameSupplier = filteredData.every((item) => item.proveedorId === supplier)
    if (isSameSupplier) {
      setValue('proveedorId', supplier)
      getDays(supplier)
    } else {
      setValue('proveedorId', '')
    }
  }
  const handleSetValueDate = async (e: any) => {
    let addDays = moment().add(days, 'days')
    setValue('fechaProgramadaProveedor', addDays.format('YYYY-MM-DD'))
  }
  const handleGetDays = async (e: any) => {
    let value = e ? e : null
    setValue('proveedorId', value.value)
    setError('proveedorId', {})
    getDays(value.value)
  }
  return (
    <ModalComponent
      show={show}
      setShow={setShow}
      title='GENERAR LOTE'
      type='modal'
      size='xl'
      showFooter={false}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className='m-2'>
          <div className='row'>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper
                labelText='Cantidad de Órdenes de Lavado'
                name='countOrder'
                disabled
              />
            </div>
          </div>
          <div className='row mb-4'>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Lugar de Lavado'
                name='lugarLavado'
                data={washingPlace}
                required
                disabled
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Proveedor'
                name='proveedorId'
                data={supplierBySite}
                onChangeValue={handleGetDays}
              />
            </div>

            <div className='col-sm-12 col-lg-3'>
              <InputDateWrapper
                labelText='Fecha Entrega a Proveedor'
                name='fechaEntregaProveedor'
                onChange={handleSetValueDate}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <InputDateWrapper
                labelText='Fecha Programada de Devolución'
                name='fechaProgramadaProveedor'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-sm-12 col-lg-6'>
              <label>Inicio de Lavado:</label>
              <Switch register={register} name='iniciarLavado' errors={errors} />
            </div>
          </div>
          <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
            <Button
              label='Generar Lote'
              typeBtn='submit'
              loading={searching}
              disabled={searching}
            />
          </ButtonWrapper>
        </form>
      </FormProvider>
    </ModalComponent>
  )
}

export {LavadoExterno}
